import { http } from "./common";
import { METHOD_DELETE } from "../constants/api";
import { SERVER_URL } from "../constants/api";
import { headersAuthSendReceiveJson } from "../headers";
import { apiHandleResponse } from "../../util/api";

const getsupplementalFileIdMappingData = async (options) => {
    return http.post(
        `/api/v2/cms/planpayercontract${
            options?.showUnmapped
                ? `?showUnMappedOnly=${options?.showUnmapped}`
                : ""
        }`,
        options
    );
};

const deleteSelectedPayerPlanIds = (options) => {
    return fetch(`${SERVER_URL}/api/v2/cms/planpayercontract`, {
        method: METHOD_DELETE,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(options),
    }).then(apiHandleResponse);
};

const downloadReport = async (payload, showUnmappedOnly) => {
    return http.post(
        `/api/v2/cms/planpayercontract/export${
            showUnmappedOnly ? "?showUnMappedOnly=true" : ""
        }`,
        payload,
        "octet-stream"
    );
};
const getPayerContracts = async () => {
    return http.get(`/api/v1/cms/payercontracts/tiny`);
};

const updatePlanPayerId = async (options) => {
    return http.put(`/api/v2/cms/planpayercontract`, options);
};

const importPlanPayers = async () => {
    return http.post(`/api/v1/cms/payerplan/import`,{});
};

export {
    getsupplementalFileIdMappingData,
    deleteSelectedPayerPlanIds,
    downloadReport,
    getPayerContracts,
    updatePlanPayerId,
    importPlanPayers
};
